import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ThemeSwitcherComponent } from '../core/components/theme-switcher/theme-switcher.component';
import { ThemeService, ThemeName } from '../core/services/theme.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    ThemeSwitcherComponent
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  @Input() title: string = 'TensorLinks';
  @Input() subTitle: string = 'Ai for healthcare';

  isEmbedded: boolean = false;
  showThemeSwitcher: boolean = false;

  constructor(private themeService: ThemeService) {}

  ngOnInit() {
    // Check if running inside an iframe
    this.isEmbedded = window.self !== window.top;

    // Only show theme switcher in dev/demo environments
    this.showThemeSwitcher = environment.showThemeSwitcher;

    // In production: apply theme from URL parameter but don't show switcher
    if (!environment.showThemeSwitcher) {
      const urlParams = new URLSearchParams(window.location.search);
      const themeParam = urlParams.get('theme');

      if (themeParam) {
        // Try to find theme by name
        const theme = this.findThemeByName(themeParam);
        if (theme) {
          // Apply the theme from URL parameter (but don't show switcher)
          this.themeService.setTheme(theme.name);
        }
      }
    }
  }

  /**
   * Find theme by name only
   * Supports: 'deeppurple-amber', 'purple-green', 'azure-blue', 'black-white'
   */
  private findThemeByName(themeName: string) {
    const normalizedInput = themeName.toLowerCase().trim();

    return this.themeService.availableThemes.find(t =>
      t.name.toLowerCase() === normalizedInput
    );
  }

  closeEmbeddedPortal() {
    // Send message to parent window to close the iframe
    if (this.isEmbedded && window.parent) {
      window.parent.postMessage({ action: 'closePatientPortal' }, '*');
    }
  }
}
